import { render, staticRenderFns } from "./vesselDetail.vue?vue&type=template&id=9713585e&scoped=true"
import script from "./vesselDetail.vue?vue&type=script&lang=js"
export * from "./vesselDetail.vue?vue&type=script&lang=js"
import style0 from "./vesselDetail.vue?vue&type=style&index=0&id=9713585e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9713585e",
  null
  
)

export default component.exports